<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="chapter"><em>Introduction</em></h1>
<p class="nonindent">A beautiful collection of original card makers’ verses and illustrations with poignant words for every occasion, written especially for handmade card makers and for those who wish to add an extra special personal touch to an otherwise blank card. Amongst the everyday greetings and salutations specially written for this book you will find extra special verses written straight from the heart. Words that were inspired by treasured moments spent with special friends and dearest relatives, some present, some past, who brought colour, comfort and love into the author’s life. These heartfelt and touching card verses capture and express many moments, thoughts, feelings and emotions not found in conventionally produced greeting cards for the mass market. They will bring life to any specially created handmade card, they will add the final touch of elegance and expression to your work of art but above all these original verses will bring joy to your heart, a smile to your face and will prove an invaluable point of reference for your card crafting and greeting needs. Simply go to the appropriate section, whether it be birthdays or bereavement, and find the verse you most identify with.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// int.vue?3288a0e9